import videojs from 'video.js';

import { Event } from '@src/types/event';

const VolumeControl = videojs.getComponent('VolumeControl');

class CustomVolumeControl extends VolumeControl {
  handleMouseDown(evt: videojs.EventTarget.Event) {
    this.player_.trigger(Event.VOLUMEBARSLIDERACTIVE);
    super.handleMouseDown(evt);
  }

  handleMouseUp(evt: videojs.EventTarget.Event) {
    this.player_.trigger(Event.VOLUMEBARSLIDERINACTIVE);
    super.handleMouseUp(evt);
  }
}

// override video.js original VolumeControl
videojs.registerComponent('VolumeControl', CustomVolumeControl);

export default CustomVolumeControl;
